/** Client-safe helpers for truck-based carrier app login. */

export const TRUCK_APP_EMAIL_DOMAIN = '@carrier-app.internal';

/** Matches typical email addresses (used to route login to user vs truck auth). */
export const EMAIL_USERNAME_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isEmailUsername(value: string): boolean {
  return EMAIL_USERNAME_PATTERN.test(value.trim());
}

export function isTruckAppServiceEmail(email: string): boolean {
  return email.endsWith(TRUCK_APP_EMAIL_DOMAIN);
}

export function normalizeLicensePlateInput(input: string): string {
  return input.trim().toUpperCase().replace(/\s+/g, '');
}

export function licensePlateMatches(storedPlate: string, loginPlate: string): boolean {
  const normalizedLogin = normalizeLicensePlateInput(loginPlate);
  if (!normalizedLogin) return false;

  const segments = storedPlate
    .split('/')
    .map((part) => normalizeLicensePlateInput(part))
    .filter(Boolean);

  if (segments.length === 0) {
    return normalizeLicensePlateInput(storedPlate) === normalizedLogin;
  }

  return segments.some((segment) => segment === normalizedLogin);
}
